import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles({
  verifyRange: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  options: {
    padding: '12px 0',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  validationError: {
    width: '100%',
    textAlign: 'left',
    marginTop: '8px',
  },
  groupPane: {
    '& > div:first-child': {
      paddingLeft: '0',
      paddingRight: '0',
    },
  },
});
